'use strict';

const SV = require('server-vars');

const scriptId = 'facebook-jssdk';
const scriptSrc = '//connect.facebook.net/en_US/all.js';

module.exports = function init() {
    if (document.querySelector('script#' + scriptId)) {
        return;
    }

    const facebookScript = document.createElement('script');
    facebookScript.id = scriptId;
    facebookScript.src = scriptSrc;

    // TODO: Check for a race condition in the actial facebook icon action. What happens if the initialization here fails and
    // someone tries to share?
    facebookScript.onload = () => {
        window.FB.init({ appId : SV.settings.socialKeys.facebook_appid, status : true, cookie : true, xfbml : true });
    };

    document.body.appendChild(facebookScript);
};



// WEBPACK FOOTER //
// ./assets/js/newPdp/helpers/facebookInit.es.js